// TODO: revisit against the documented pattern — https://lit.dev/docs/components/styles/#sharing-styles
import modernNormalizeCssText from 'bundle-text:../static/style/modern-normalize.css';
import globalCssText from 'bundle-text:../static/style/global.css';
import utilsCssText from 'bundle-text:../static/style/utils.css';

export const modernNormalizeStyleSheet = new CSSStyleSheet();
modernNormalizeStyleSheet.replaceSync(modernNormalizeCssText);

export const globalStyleSheet = new CSSStyleSheet();
globalStyleSheet.replaceSync(globalCssText);

export const utilsStyleSheet = new CSSStyleSheet();
utilsStyleSheet.replaceSync(utilsCssText);
